export default __webpack_public_path__ + "static/media/avatar_54.a07ccd10.png";